import useGetProductsAndRelatedDataByIds from './useGetProductsAndRelatedDataByIds'

export default useGetProductsAndRelatedDataByIds
